import { CondicoesContratacaoService } from './../../services/condicoes-contratacao.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { isSafeHtml } from '@utils/html-sanitizer.util';
import { ToastrService } from 'ngx-toastr';
import { HttpResponse } from '@angular/common/http';
import { FilenameParser } from '@utils/FilenameParser';
import { FileDownloadService } from '@services/file-download.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-condicoes-contratacao',
    templateUrl: './condicoes-contratacao.component.html',
    styleUrls: ['./condicoes-contratacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, BreadcrumbComponent, FooterComponent]
})
export class CondicoesContratacaoComponent implements OnInit {
  public loadingGenerico: boolean = false;
  public empresa: any = localStorage.idEmpresaLogada;
  public attachmentDownload: string;

  public resources: any;
  public html: any;

  constructor(
    private readonly condicoesContratacaoService: CondicoesContratacaoService,
    private readonly sanitizer: DomSanitizer,
    private readonly Toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getAllHistorico();
  }

  public downloadContratos() {
    this.loadingGenerico = true;
    this.condicoesContratacaoService
      .getUrlContrato()
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.loadingGenerico = false;
          
          const urlWithoutDomain: string = response.response.url.split('/').slice(3).join('/');

          this.condicoesContratacaoService.dowloadArquivoPdf(urlWithoutDomain)
            .pipe(take(1))
            .subscribe({
              next: ({body, headers}: HttpResponse<any>) => {
                this.loadingGenerico = false;
                const filename = FilenameParser.fromContentDispositionHeader(
                  headers.get('content-disposition'),
                  'Contrato.pdf'
                );
                FileDownloadService.download([body], filename);
              },
              error: (error) => {
                this.loadingGenerico = false;
                console.error(error);
              }
            })
        },
        error: (error: any) => {
          this.loadingGenerico = false;
          console.error(error);
        }
      });
  }

  public getAllHistorico() {
    this.loadingGenerico = true;
    this.condicoesContratacaoService
      .getCondicoes(this.empresa)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.loadingGenerico = false;
          this.resources = success.response;
          this.attachmentDownload = success.response.uriAnexoContratoComercial;
          if (isSafeHtml(success.response.prazoEntrega)) {
            this.html = this.sanitizer.bypassSecurityTrustHtml( // NOSONAR - S6268
              success.response.prazoEntrega
            );
          }
        },
        error: (error: any) => {
          this.loadingGenerico = false;
          this.Toastr.error('Erro ao carregar condições de contratação !');
        }
      })
  }
}
